import React from 'react';

const Button = props => {
    let icon;
    if (props.loading) {
        icon = (
            <i className="mr-2 fas fa-circle-notch fa-spin"></i>
        )
    } else {
        icon = (
            <span className="btn-inner--icon mr-2">
                <i className={props.iconClassName}/>
            </span>
        )
    }

    return (
        <button
            type="button"
            style={props.style}
            className={`btn btn-sm btn-primary mr-3 ${props.className} ${props.loading ? "btn-secondary":""}`}
            onClick={props.loading ? null : props.onClick}
        >
            {icon}
            {props.children}
        </button>
    )
};

export default Button;
